<template>
    <div class="section-pages">
      <component-loader :progress="90" v-if="showLoader" :unlimitedProgress="true" :activeClose="true" v-on:close="showLoader = false"></component-loader>

      <div class="pages-sidebar head">
        <div class="table-title">
            <p>{{$t('dash.pages.title')}}</p>
        </div>
      </div>
        <vs-row>
            <vs-col vs-justify="center" vs-align="center" vs-w="12">
                <!--<div class="table-title">
                    <p>{{$t('dash.pages.title')}}</p>
                </div>-->
                <!--<p class="subtitle">{{$t('dash.pages.subtitle')}}</p>-->

              <template v-if="['Admin', 'Editor'].includes(getUserRole)">
                <Tooltip v-if="checkLock('pages')" :text="$t('dash.locked')" position="top">
                    <vs-button
                            color="#303030"
                            class="btn-large btn-img"
                            @click="addPage"
                            vs-type="filled"
                            disabled
                    >
                        <!--<p>{{$t('dash.pages.add')}}</p>-->
                        <p>{{$t('dash.pages.overlay.title')}}</p>
                        <img src="../../../assets/img/icon_connect_white.svg" alt="new">
                    </vs-button>
                </Tooltip>
                <vs-button
                        v-if="!checkLock('pages')"
                        color="#303030"
                        class="btn-large btn-img"
                        @click="addPage"
                        vs-type="filled"
                >
                    <!--<p>{{$t('dash.pages.add')}}</p>-->
                    <p>{{$t('dash.pages.overlay.title')}}</p>
                    <img src="../../../assets/img/icon_connect_white.svg" alt="new">
                </vs-button>
                <vs-button
                        v-if="checkLock('pages')"
                        @click="goToSettings"
                        class="btn-large btn-img"
                        color="#303030"
                        vs-type="filled"
                >
                    <p>{{$t('dash.button.changeplan')}}</p>
                    <img src="../../../assets/img/icon_unlock.svg" alt="unlock">
                </vs-button>
                <vs-button
                        v-if="checkLock('admin')"
                        color="#303030"
                        class="btn-large"
                        @click="addGroup"
                        vs-type="filled"
                >
                    <p>{{$t('dash.pages.group.add')}}</p>
                </vs-button>
              </template>

                <div class="search-page">
                  <vs-input
                    @keypress.enter.prevent
                    v-model="pageFilter"
                    :class="{'input': true}"
                    color="#B20564"
                    class="inputx"
                    icon-after="true"  icon="search"
                    :placeholder="$t('dash.settings.user.label.page_filter')"
                  />
                </div>

                <vs-popup class="overlay groups" 
                          :title="$t('dash.pages.group.overlay.title')" 
                          :active.sync="popupGroup">
                          
                  <component-groups
                    :group="group"
                    :pages="linked"
                    :groups="groups"
                    v-on:close="closeGroupOverlay"
                    v-if="popupGroup"
                  ></component-groups>

                </vs-popup>

                <vs-popup
                        class="overlay media-overlay"
                        :title="$t('dash.pages.overlay.title')"
                        :active.sync="popup0"
                >
                    <div class="subtitle">
                        <img src="../../../assets/img/icon_connect_pink.svg" alt="connexion">
                        <p>
                            {{$t('dash.pages.overlay.txt0')}}
                            <br>
                            {{$t('dash.pages.overlay.txt1')}}
                        </p>
                    </div>

                    <!-- SOCIAL NETWORK CONNECT BUTTONS-->
                    <div class="rs-buttons">
                        <!-- <button class="facebook-btn" @click="facebookLogout">{{$t('dash.pages.overlay.logout')}}</button> -->
                        <!-- <button class="facebook-btn" @click="connectFB">Connect</button> -->
                        <Tooltip :text="$t('dash.pages.facebook_connect')" position="top">
                          <vs-button class="facebook-btn btn-img btn-large" @click="connectFB">
                            <!--<p v-if="!connected.facebook">{{$t('dash.pages.overlay.connect')}}</p>
                            <p v-else>{{$t('dash.pages.overlay.choose')}}</p>-->
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/ico-facebook-circle.png" alt="facebook">
                          </vs-button>
                          &nbsp;
                        </Tooltip> 
                        
                        <!-- <Tooltip :text="$t('dash.pages.whatsapp_connect')" position="top">
                          <vs-button class="facebook-btn btn-img btn-large" @click="connectWhatsapp">
                            <p>{{$t('dash.pages.overlay.choose')}} whatsapp</p>
                            <img src="../../../assets/img/ico-facebook-circle.png" alt="whatsapp">
                          </vs-button>
                          &nbsp;
                        </Tooltip>  -->

                        <!-- <Tooltip :text="$t('dash.pages.facebook_groups_connect')" position="top">
                          <vs-button class="facebook-btn btn-img btn-large" @click="openGroupsFBPopup">
                            <p>{{$t('dash.groups.overlay.choose')}}</p>
                            <img src="../../../assets/img/ico-facebook-circle.png" alt="facebook">
                          </vs-button>
                          &nbsp;
                        </Tooltip>    -->
                        
                        <Tooltip :text="$t('dash.pages.instagram_connect')" position="top" v-if="!connected.instagram && checkLock('instagram') && !checkLock('partner') && hideToFB">
                          <vs-button class="instagram-btn btn-img btn-large" @click="connectInsta">
                            <!--<p v-if="!connected.facebook">{{$t('dash.pages.overlay.connect')}}</p>
                            <p v-else>{{$t('dash.pages.overlay.choose')}}</p>-->
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/ico-instagram-circle.svg" alt="instagram">
                          </vs-button>
                          &nbsp;
                        </Tooltip> 
                        <template v-else-if="!connected.instagram && checkLock('instagram') && !checkLock('partner') && !hideToFB">
                          <div class="wrapper-connect-choice">
                            <Tooltip :text="$t('dash.pages.instagram_connect')" position="top">
                              <vs-button class="instagram-btn btn-img btn-large" @click="connectInsta">
                                <p>{{$t('dash.pages.overlay.connect')}}</p>
                                <img src="../../../assets/img/ico-instagram-circle.svg" alt="instagram">
                              </vs-button>
                              &nbsp;
                            </Tooltip>
                            <div class="connect-type" v-if="activeInstagramConciergerie">
                              <Tooltip :text="$t('dash.pages.instagram_connect.sandard')" position="top">
                                <vs-button class="instagram-btn" @click="connectInsta">
                                  <p>{{$t('dash.pages.overlay.connect.sandard')}}</p>
                                </vs-button>
                                &nbsp;
                              </Tooltip>
                              <Tooltip :text="$t('dash.pages.instagram_connect.conciergerie')" position="top">
                                <vs-button class="instagram-btn" @click="connectInstaDirect">
                                  <p>{{$t('dash.pages.overlay.connect.conciergerie')}}</p>
                                </vs-button>
                                <span></span>
                              </Tooltip>
                            </div>
                          </div>
                        </template>
                        
                        <template v-else>
                            <!-- Instagram disabled, show disabled button -->
                            <Tooltip
                                    position="top"
                                    :text="$t('dash.locked')"
                            >
                                <vs-button
                                        class="instagram-btn btn-img btn-large"
                                        disabled
                                >
                                    <p>{{$t('dash.pages.overlay.connect')}}</p>
                                    <img
                                            src="../../../assets/img/ico-instagram-circle.svg"
                                            alt="instagram"
                                    >
                                </vs-button>
                                &nbsp;
                            </Tooltip>
                        </template>

                        <template v-if="!connected.linkedin && checkLock('linkedin') && !checkLock('partner')">
                          <Tooltip :text="$t('dash.pages.linkedin_connect')">
                            <vs-button
                                    class="linkedin-btn btn-img btn-large"
                                    @click="connectLinkedin"
                            >
                                <p>{{$t('dash.pages.overlay.connect')}}</p>
                                <img
                                        src="../../../assets/img/ico-linkedin-circle.svg"
                                        alt="linkedin"
                                >
                            </vs-button>
                            &nbsp;
                          </Tooltip>
                        </template>
                        <template v-else>
                            <!-- LinkedIn disabled, show disabled button -->
                            <Tooltip
                                    position="top"
                                    :text="$t('dash.locked')"
                            >
                                <vs-button
                                        class="linkedin-btn btn-img btn-large"
                                        disabled
                                >
                                    <p>{{$t('dash.pages.overlay.connect')}}</p>
                                    <img
                                            src="../../../assets/img/ico-linkedin-circle.svg"
                                            alt="linkedin"
                                    >
                                </vs-button>
                                &nbsp;
                            </Tooltip>
                        </template>

                        <Tooltip :text="$t('dash.pages.google_connect')" position="top" v-if="activeFeature('google')">
                          <vs-button ref="loadingBotTarget"
                            class="btn-img btn-large google-btn vs-con-loading__container" 
                            @click.prevent="loginWithGoogle">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/ico-google-circle.png"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>

                        <template v-if="!connected.twitter && checkLock('twitter_allowed')">
                          <Tooltip :text="$t('dash.pages.twitter_connect')">
                            <vs-button
                                    class="twitter-btn btn-img btn-large"
                                    @click="connectTwitter"
                            >
                                <p>{{$t('dash.pages.overlay.connect')}}</p>
                                <img
                                        src="../../../assets/img/icon_tw.png"
                                        alt="twitter"
                                        style="border-radius:50%;"
                                >
                            </vs-button>
                            &nbsp;
                          </Tooltip>
                        </template>
                        <template v-else>
                            <!-- Twitter disabled, show disabled button -->
                            <Tooltip
                                    position="top"
                                    :text="$t('dash.locked')"
                            >
                                <vs-button
                                        class="twitter-btn btn-img btn-large"
                                        disabled
                                >
                                    <p>{{$t('dash.pages.overlay.connect')}}</p>
                                    <img
                                            src="../../../assets/img/icon_tw.png"
                                            alt="twitter"
                                            style="border-radius:50%;"
                                    >
                                </vs-button>
                                &nbsp;
                            </Tooltip>
                        </template>

                        <Tooltip :text="$t('dash.pages.threads_connect')" position="top" v-if="activeFeature('threads')">
                          <vs-button ref="loadingBotTarget"
                            class="btn-img btn-large threads-btn vs-con-loading__container" 
                            @click.prevent="loginWithThreads">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/ico-threads-circle.svg"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>

                        <Tooltip :text="$t('dash.pages.youtube_connect')" position="top" v-if="activeFeature('youtube')">
                          <vs-button ref="loadingBotTarget"
                            class="btn-img btn-large youtube-btn vs-con-loading__container" 
                            @click.prevent="loginWithYoutube">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/ico-youtube-circle.svg"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>

                        <template v-if="!connected.tiktok && checkLock('tiktok') && !checkLock('partner')">
                          <Tooltip :text="$t('dash.pages.tiktok_connect')" position="top">
                            <vs-button class="tiktok-btn btn-img btn-large" @click="connectTiktok">
                              <p>{{$t('dash.pages.overlay.connect')}}</p>
                              <img src="../../../assets/img/ico-tiktok-circle.png" alt="tiktok">
                            </vs-button>
                            &nbsp;
                          </Tooltip>
                        </template>
                        <template v-else>
                            <!-- Tiktok disabled, show disabled button -->
                            <Tooltip
                                    position="top"
                                    :text="$t('dash.locked')"
                            >
                                <vs-button
                                        class="tiktok-btn btn-img btn-large"
                                        disabled
                                >
                                    <p>{{$t('dash.pages.overlay.connect')}}</p>
                                    <img
                                            src="../../../assets/img/ico-tiktok-circle.png"
                                            alt="tiktok"
                                    >
                                </vs-button>
                                &nbsp;
                            </Tooltip>
                        </template>

                        <!-- <Tooltip :text="$t('dash.pages.whatsapp_connect')" position="top" v-if="activeFeature('whatsapp')">
                          <vs-button ref="loadingBotTarget"
                            class="btn-img btn-large whatsapp-btn vs-con-loading__container" 
                            @click.prevent="loginWithThreads">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/ico-whatsapp-circle.svg"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip> -->

                        <Tooltip :text="$t('dash.pages.pinterest_connect')" position="top" v-if="activeFeature('pinterest')">
                          <vs-button ref="loadingBotTarget"
                            class="btn-img btn-large pinterest-btn" 
                            @click.prevent="loginWithPinterest">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/ico-pinterest-circle.png"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>

                        <Tooltip :text="$t('dash.pages.telegram_connect')" position="top">
                          <vs-button ref="loadingBotTarget"
                            class="btn-img btn-large telegram-btn vs-con-loading__container" 
                            @click="openTelegramPopup">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/icon_telegram.png"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>
                        
                      </div>

                      
                      <div class="subtitle" style="margin-top:30px;" v-if="activeFeature('push_notif_pub')">
                        <img src="../../../assets/img/icon_bell_notification_ting_pink.svg" alt="connexion">
                        <p>
                            {{$t('dash.pages.overlay.notifications.txt0')}}
                        </p>
                      </div>

                      <div class="rs-buttons" style="margin-top:15px;" v-if="activeFeature('push_notif_pub')">

                        <Tooltip :text="$t('dash.pages.oneSignal_connect')" position="top">
                          <vs-button
                            class="btn-img btn-large oneSignal-btn"
                            @click="openPushPopup('oneSignal')">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/icon_onesignal.png"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>

                        <Tooltip :text="$t('dash.pages.wonderpush_connect')" position="top">
                          <vs-button
                            class="btn-img btn-large wonderpush-btn" 
                            @click="openPushPopup('wonderpush')">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/icon_wonderpush.png"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>

                        <Tooltip :text="$t('dash.pages.batch_connect')" position="top">
                          <vs-button
                            class="btn-img btn-large batch-btn" 
                            @click="openPushPopup('batch')">
                            <p>{{$t('dash.pages.overlay.connect')}}</p>
                            <img src="../../../assets/img/icon_batch.png"/>
                          </vs-button>
                          &nbsp;
                        </Tooltip>

                        <!-- <vs-button
                          color="#4a68ad"
                          v-if="connected.facebook || connected.twitter"
                          class="btn-large"
                          @click="popup1=true"
                        >{{$t('dash.pages.overlay.choose')}}</vs-button>-->
                    </div>
                    <!-- END SOCIAL NETWORK CONNECT BUTTONS-->

                </vs-popup>

                <!-- Debut de Popup pour Telegram -->
                <vs-popup class="overlay" 
                          :title="$t('dash.pages.telegram_connect')" 
                          :active.sync="popupTelegram">
                  <div class="telegram-popup">
                    <ol class="telegram-instructions">
                      <li>
                        {{$t('dash.pages.telegram_instructions_1_1')}} 
                        <b class="botname">{{telegramBotName}}</b>
                        {{$t('dash.pages.telegram_instructions_1_2')}}
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="() => openTelegramHelpGif(1)" class='telegram-help'/>
                      </li>
                      <li>
                        {{$t('dash.pages.telegram_instructions_2')}}
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="() => openTelegramHelpGif(2)" class='telegram-help'/>
                      </li>
                      <li>
                        {{$t('dash.pages.telegram_instructions_3')}}
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="() => openTelegramHelpGif(3)" class='telegram-help'/>
                      </li>
                      <li>
                        {{$t('dash.pages.telegram_instructions_4')}}
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="() => openTelegramHelpGif(4)" class='telegram-help'/>
                      </li>
                    </ol>
                    <vs-input :placeholder="$t('dash.pages.telegram_channel_placeholder')" 
                              v-model="telegramChannelUrl"
                              :label="$t('dash.pages.telegram_channel_label')"
                              :danger="!telegramChannelUrlIsCorrect"
                              :danger-text="$t('dash.pages.telegram_channel_url_error')"/>
                    <vs-button @click="validateTelegramChanel">
                      {{$t('dash.pages.overlay.connect')}}
                    </vs-button>
                  </div>
                  <vs-popup class="help-popup" 
                    :title="telegramInstructionGif === 1 ? $t(`dash.pages.telegram_instructions_${telegramInstructionGif}_1`) + ' ' + telegramBotName + 
                    ' ' + $t(`dash.pages.telegram_instructions_${telegramInstructionGif}_2`) : $t(`dash.pages.telegram_instructions_${telegramInstructionGif}`)" 
                    :active.sync="telegramPopupHelp">
                    <img :src="require(`../../../assets/img/MW_Telegram_Instruction_${telegramInstructionGif}.gif`)" alt="aide" class="gif-help"/>
                  </vs-popup>
                </vs-popup>
                <!-- Fin de Popup pour Telegram -->

                <!-- Debut de Popup pour Groups FB -->
                <vs-popup class="overlay" 
                          :title="$t('dash.pages.groups_FB_connect')" 
                          :active.sync="popupGroupsFB">
                  <div class="groups-fb-popup">
                    <ol class="groups-fb-instructions">
                      <li>
                        {{$t('dash.pages.groups_fb_instructions_1')}}
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="openGroupsFBHelpGif(1)" class='groups-fb-help'/>
                      </li>
                      <li>
                        {{$t('dash.pages.groups_fb_instructions_2')}}
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="openGroupsFBHelpGif(2)" class='groups-fb-help'/>
                      </li>
                      <li>
                        {{$t('dash.pages.groups_fb_instructions_3')}}
                        <img src="../../../assets/img/icon_help.svg" alt="?" @click="openGroupsFBHelpGif(3)" class='groups-fb-help'/>
                      </li>
                      <li>{{$t('dash.pages.groups_fb_instructions_4')}}</li>
                    </ol>
                    <vs-button @click="connectGroupsFB">
                      {{$t('dash.pages.overlay.connect')}}
                    </vs-button>
                  </div>
                  <vs-popup class="help-popup" 
                    :title="$t(`dash.pages.groups_fb_instructions_${groupsFBInstructionGif}`)" 
                    :active.sync="groupsFBPopupHelp">
                    <img :src="require(`../../../assets/img/MW_Groups_FB_Instructions_${groupsFBInstructionGif}.gif`)" alt="aide" class="gif-help"/>
                  </vs-popup>
                </vs-popup>
                <!-- Fin de Popup pour Groups FB -->

                <!-- Debut de Popup pour Push -->
                <vs-popup class="overlay" 
                          :title="$t(`dash.pages.${popupPush.network}_connect`)" 
                          :active.sync="popupPush.active">
                  <div :class="`${popupPush.network}-popup`">
                    <p :class="`${popupPush.network}-instructions`">
                      {{ $t(`dash.pages.${popupPush.network}_help`) }}
                      <img src="../../../assets/img/icon_help.svg" alt="?" @click="openPushNotifHelpGif()" :class="`${popupPush.network}-help`"/>  
                    </p>
                    <vs-input :placeholder="$t(`dash.pages.${popupPush.network}_name_placeholder`)" 
                              v-model="popupPush.name"
                              :label="$t(`dash.pages.${popupPush.network}_name_label`)"
                              :danger="!popupPush.isCorrect && (!popupPush.name || popupPush.name == '')"
                              :danger-text="'required'"/>
                    <vs-input :placeholder="$t(`dash.pages.${popupPush.network}_network_id_placeholder`)" 
                              v-model="popupPush.network_id"
                              :label="$t(`dash.pages.${popupPush.network}_network_id_label`)"
                              :danger="!popupPush.isCorrect && (!popupPush.network_id || popupPush.network_id == '')"
                              :danger-text="'required'"/>
                    <vs-input :placeholder="$t(`dash.pages.${popupPush.network}_token_placeholder`)" 
                              v-model="popupPush.token"
                              :label="$t(`dash.pages.${popupPush.network}_token_label`)"
                              :danger="!popupPush.isCorrect && (!popupPush.token || popupPush.token == '')"
                              :danger-text="'required'"/>
                    <vs-button @click="validatePopupPush">
                      {{$t('dash.pages.overlay.connect')}}
                    </vs-button>
                  </div>
                  <vs-popup class="help-popup" 
                    :title="$t(`dash.pages.${popupPush.network}_help`)" 
                    :active.sync="pushNotifPopupHelp"
                    v-if="popupPush.active">
                    <img :src="require(`../../../assets/img/${popupPush.network}_help.jpg`)" alt="aide" class="gif-help"/>
                  </vs-popup>
                </vs-popup>
                <!-- Fin de Popup pour Telegram -->

                <vs-popup
                        class="overlay pages-overlay facebook-overlay linkedin-overlay"
                        :title="$t(`dash.pages.add${getTypeNetwork}`)"
                        :active.sync="popup1"
                >
                    <component-pages-overlay
                            v-if="popup1"
                            :liked="this.linked"
                            :unliked="this.unlinked.filter(unlk => !this.linked.some((lk) => unlk.network_id.toString() === lk.network_id.toString()))"
                            :network="this.network"
                            :isGroup="this.isGroup"
                            v-on:close="validate"
                    ></component-pages-overlay>
                </vs-popup>

                <div class="pages-content">
                  <div class="groups" v-if="groups && groups.length > 0 && linked.length && getGroupFilter().length" :class="[{'hide': !groups.some(g => checkPagesInGroup(g))}]">
                    <div class="title">{{ $t('dash.pages.groups') }} <span>({{ groups.filter(g => checkPagesInGroup(g)).length}})</span></div>
                    <ul>
                      <li class="group" v-for="item in groups" :key="item.id" :class="[{'hide': !checkPagesInGroup(item) || checkGroupFilter(item)}]">
                        <div class="name">{{ item.name }} <span>({{ item.pages.filter(p => findPage(p)).length }})</span></div>
                        <div class="edit" @click="editGroup(item)" v-if="checkLock('admin')">{{ $t('dash.pages.groups.edit') }}</div>
                        <div class="to-show" @click="toggleShowGroup(item)">
                          <img v-if="item.show" alt="hide group" class="hide-group" src="../../../assets/img/icon-hide-group-1.svg"/>
                          <img v-else alt="show group" class="show-group" src="../../../assets/img/icon-show-group-1.svg"/>
                          <span v-if="item.show" class="hide-group">{{ $t('dash.pages.group.hide') }}</span>
                          <span v-else class="show-group">{{ $t('dash.pages.group.show') }}</span>
                        </div>
                        <ul :class="[{'show': item.show}]">
                          <div v-for="pageId in item.pages" :key="pageId" :class="[{'hide': !checkPageFilter(findPage(pageId))}]">
                            <li class="page"  v-if="findPage(pageId)" :class="{disabled: !checkLock(findPage(pageId).network) || (!isUserPremiumActive && orderedPages.length && orderedPages[0].id != pageId && !isUserPartner)}">
                              <page-image-avatar :page="findPage(pageId)"/>
                              <p class="page-name">
                                {{ findPage(pageId).name }}
                                <!-- <Tooltip text="Conciergerie" position="top">
                                  <img v-if="findPage(pageId).instagram_username" class="conciergerie" src="../../../assets/img/bell_concierge.svg" @click="goToBot(findPage(pageId).id, 'connection')" /> 
                                  &nbsp;
                                </Tooltip> -->
                                <component-conciergerie 
                                  v-if="activeLinkedinConciergerie || activeInstagramConciergerie"
                                  :page="findPage(pageId)" 
                                  v-on:getPagesEvent="getPagesEvent"
                                  v-on:closeActiveConciergerie="closeActiveConciergerie"
                                ></component-conciergerie>
                                <Tooltip text="Conciergerie" position="top" v-else-if="['instagram', 'linkedin'].includes(findPage(pageId).network)">
                                  <img class="conciergerie" src="../../../assets/img/bell_concierge.svg" @click="changePlanConciergerie = true" /> 
                                  &nbsp;
                                </Tooltip>
                              </p> 
                            <template v-if="['Admin', 'Editor'].includes(getUserRole)">
                              <vs-button 
                                v-if="!checkLock(findPage(pageId).network) || (!isUserPremiumActive && orderedPages.length && orderedPages[0].id != pageId && !isUserPartner)"
                                color="#6a1f4c"
                                class="btn-large btn-img remove">
                                <!-- <img src="../../../assets/img/icon-delete.svg" alt="remove"> -->
                                <i class="material-icons">delete</i>
                                <p>{{ $t('dash.pages.group.remove') }}</p>
                              </vs-button>
                              <vs-button 
                                v-else
                                @click="deleteLinkedFromGroup(findPage(pageId), item)"
                                color="#6a1f4c"
                                class="btn-large btn-img remove">
                                <!-- <img src="../../../assets/img/icon-delete.svg" alt="remove"> -->
                                <i class="material-icons">delete</i>
                                <p>{{ $t('dash.pages.group.remove') }}</p>
                              </vs-button>
                              <!-- <vs-button @click="disconnectConciergerie(pageId)" v-if="findPage(pageId).story_config && (findPage(pageId).story_config.cookies || findPage(pageId).story_config.session_state)" color="#6a1f4c" class="btn-large btn-img remove disconnect-conciergerie">
                                <p>{{$t("dash.pages.disconnect_conciergerie")}}</p>
                            </vs-button> -->

                              <div class="border"></div> 
                            </template>
                              <!-- <vs-button 
                                @click="confirmRefresh(findPage(pageId))"
                                color="#6a1f4c"
                                class="refresh btn-large">
                                <p>Actualiser token</p>
                              </vs-button> -->
                              
                              <div class="status-refresh">                                
                                <template v-if="(activeLinkedinConciergerie || activeInstagramConciergerie) && !!findPage(pageId).bot_status && findPage(pageId).instagram_username && (!findPage(pageId).story_config || !findPage(pageId).story_config.created)">
                                  <Tooltip
                                    :text="$t('dash.bots.status_proxy')"
                                    position="top"
                                    class="reconnect-btn"
                                  >
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="
                                        require('../../../assets/img/icon_wait_proxy.svg')
                                      "
                                      @click="reconnectePage(pageId)"
                                    />
                                    <a
                                      href="#"
                                      @click="reconnectePage(pageId)"
                                      v-html="$t('dash.pages.reconnectLabel')"
                                    ></a>
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template>
                                <template v-else-if="(activeLinkedinConciergerie || activeInstagramConciergerie) && findPage(pageId).isGroup && findPage(pageId).network == 'instagram' && (!findPage(pageId).story_config || !findPage(pageId).story_config.created)">
                                  <Tooltip
                                    :text="$t('dash.bots.status_proxy')"
                                    position="top"
                                    class="reconnect-btn"
                                  >
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="
                                        require('../../../assets/img/icon_wait_proxy.svg')
                                      "
                                      @click="reconnectePage(pageId)"
                                    />
                                    <a
                                      href="#"
                                      @click="reconnectePage(pageId)"
                                      v-html="$t('dash.pages.reconnectLabel')"
                                    ></a>
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template>
                                <template v-else-if="findPage(pageId).isGroup && findPage(pageId).network == 'instagram'">
                                  <Tooltip
                                    :text="$t('dash.bots.conciergerie-ok')"
                                    position="top"
                                    class="full-conciergerie"
                                  >
                                  <span class="border"></span>
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="
                                      require('../../../assets/img/icon_check_light.svg')
                                    "
                                  />
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template>
                                <template v-if="!checkLock(findPage(pageId).network) || (!isUserPremiumActive && orderedPages.length && orderedPages[0].id != findPage(pageId).id && !isUserPartner)">
                                  <Tooltip
                                    :text="getTooltipText(findPage(pageId))"
                                    position="top"
                                  >
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="
                                        require('../../../assets/img/icon_check_light.svg')
                                      "
                                    />
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template> 
                                <template v-else-if="findPage(pageId).isGroup && findPage(pageId).network == 'instagram'">
                                  <Tooltip :text="$t('dash.bots.conciergerie-ok-api-ko')" position="top">
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="require('../../../assets/img/icon-delete.svg')"
                                      @click="confirmRefresh(findPage(pageId))"
                                    />
                                    <!-- <a
                                      href="#"
                                      @click="confirmRefresh(findPage(pageId))"
                                      v-html="$t('dash.pages.refreshLabel')"
                                    ></a> -->
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template>
                                <template v-else-if="!!findPage(pageId).bot_status && findPage(pageId).bot_status == 1">
                                  <!-- <Tooltip
                                    :text="$t('dash.pages.status_running') + (findPage(pageId).network == 'linkedin' ? ` - ${$t('dash.bots.next_refresh')} ${dateFromNow(findPage(pageId).expires_at)}` : '')"
                                    position="top"
                                  > -->
                                  <Tooltip
                                    :text="getTooltipText(findPage(pageId))"
                                    position="top"
                                  >
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="
                                        require('../../../assets/img/icon_check_light.svg')
                                      "
                                      @click="confirmRefresh(findPage(pageId))"
                                    />
                                    <!-- <a
                                      href="#"
                                      @click="confirmRefresh(findPage(pageId))"
                                      v-html="$t('dash.pages.refreshLabel')"
                                    ></a> -->
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template>
                                <template v-else-if="!!findPage(pageId).bot_status && findPage(pageId).bot_status == 2">
                                  <Tooltip :text="$t('dash.bots.status_near_expiration')+new Date(findPage(pageId).bot_error).toLocaleDateString()" position="top">
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="require('../../../assets/img/icon_warn.svg')"
                                      @click="confirmRefresh(findPage(pageId))"
                                    />
                                    <a
                                      href="#"
                                      @click="confirmRefresh(findPage(pageId))"
                                      v-html="$t('dash.pages.refreshLabel')"
                                    ></a>
                                  </Tooltip>
                                </template>
                                <template v-else-if="findPage(pageId).bot_status == 0 && !checkLock('source_choice')">
                                  <Tooltip :text="findPage(pageId).bot_error" position="top">
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="require('../../../assets/img/icon_stop.svg')"
                                      @click="['Admin', 'Editor'].includes(getUserRole) ? goToSettings() : null"
                                    />
                                    <a
                                      href="#"
                                      @click="confirmRefresh(findPage(pageId))"
                                      v-html="$t('dash.pages.refreshLabel')"
                                    ></a>
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template>
                                <template v-else-if="findPage(pageId).bot_status == 0 && findPage(pageId).network == 'linkedin'">
                                  <Tooltip :text="$t('dash.bots.status_expired')" position="top">
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="require('../../../assets/img/icon_stop.svg')"
                                      @click="confirmRefresh(findPage(pageId))"
                                    />
                                    <a
                                      href="#"
                                      @click="confirmRefresh(findPage(pageId))"
                                      v-html="$t('dash.pages.refreshLabel')"
                                    ></a>
                                  </Tooltip>
                                </template>
                                <template v-else-if="findPage(pageId).bot_status == 3">
                                  <Tooltip :text="$t(findPage(pageId).bot_error)" position="top">
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="require('../../../assets/img/icon_stop.svg')"
                                      @click="['Admin', 'Editor'].includes(getUserRole) ? reactivateBot(pageId) : null"
                                    />
                                    <a
                                      href="#"
                                      @click="['Admin', 'Editor'].includes(getUserRole) ? reactivateBot(pageId) : null"
                                      v-html="$t('dash.sources.enable')"
                                    ></a>
                                    <span>&nbsp;</span>
                                  </Tooltip>
                                </template>
                                <template v-else-if="checkLock(findPage(pageId).network)">
                                  <Tooltip :text="findPage(pageId).bot_error" position="top">
                                    <vs-avatar
                                      color="transparent"
                                      size="18px"
                                      :src="require('../../../assets/img/icon_stop.svg')"
                                      @click="confirmRefresh(findPage(pageId))"
                                    />
                                    <a
                                      href="#"
                                      @click="confirmRefresh(findPage(pageId))"
                                      v-html="$t('dash.pages.refreshLabel')"
                                    ></a>
                                  </Tooltip>
                                </template>
                                <template v-else>
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="require('../../../assets/img/icon_stop.svg')"
                                    style="cursor: default;"
                                    @click="confirmRefresh(findPage(pageId))"
                                  />
                                  <a
                                    href="#"
                                    @click="confirmRefresh(findPage(pageId))"
                                    v-html="$t('dash.pages.refreshLabel')"
                                  ></a>
                                </template>
                              </div>
                              <div class="type">{{ findPage(pageId).network }}</div>
                            </li>
                          </div>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div class="pages" v-if="listPages.length && getPageFilter().length">
                    <div class="title">{{ $t('dash.pages.groups.without') }} <span>({{ listPages.length }})</span></div> <!---->
                    <vs-table :hoverFlat="true" :data="listPages">
                      <template slot="thead">
                        <vs-th class="name" sortKey="name">Nom</vs-th>
                        <vs-th class="type" sortKey="network">Type</vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr :key="item.id" v-for="(item, index) in data" :class="[{hide: !checkPageFilter(item), disabled: !checkLock(item.network) || (!isUserPremiumActive && orderedPages.length && orderedPages[0].id != item.id && !isUserPartner)}]">
                          <vs-td class="name" :data="item.name">
                            <page-image-avatar :page="item"/>
                            <p class="page-name">
                              {{ item.name }}
                              <!-- <Tooltip text="Conciergerie" position="top">
                                <img v-if="item.instagram_username" class="conciergerie" src="../../../assets/img/bell_concierge.svg" @click="goToBot(item.id, 'connection')" /> 
                                &nbsp;
                              </Tooltip> -->
                              <component-conciergerie 
                                  v-if="activeLinkedinConciergerie || activeInstagramConciergerie"
                                  :page="item" 
                                  v-on:getPagesEvent="getPagesEvent"
                                  v-on:closeActiveConciergerie="closeActiveConciergerie"
                                ></component-conciergerie>
                                <Tooltip text="Conciergerie" position="top" v-else-if="['instagram', 'linkedin'].includes(item.network)">
                                  <img class="conciergerie" src="../../../assets/img/bell_concierge.svg" @click="changePlanConciergerie = true" /> 
                                  &nbsp;
                                </Tooltip>
                            </p>
                            <div style="">
                            
                            </div>
                            
                          </vs-td>

                          <vs-td class="type" :data="item.network">
                            {{ item.network }}
                          </vs-td>

                          <vs-td>
                            <!-- <vs-button 
                              @click="confirmRefresh(item)"
                              color="#6a1f4c"
                              class="refresh btn-large">
                              <p>Actualiser token</p>
                            </vs-button> -->

                            <div class="status-refresh">
                              <template v-if="(activeLinkedinConciergerie || activeInstagramConciergerie) && item.bot_status && item.instagram_username && (!item.story_config || !item.story_config.created)">
                                <Tooltip
                                  :text="$t('dash.bots.status_proxy')"
                                  position="top"
                                  class="reconnect-btn-list"
                                >
                                <span class="border"></span>
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="
                                      require('../../../assets/img/icon_wait_proxy.svg')
                                    "
                                    @click="reconnectePage(item.id)"
                                  />
                                  <a
                                    @click="reconnectePage(item.id)"
                                    v-html="$t('dash.pages.reconnectLabel')"
                                  ></a>
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template>
                              <template v-else-if="(activeLinkedinConciergerie || activeInstagramConciergerie) && item.isGroup && item.network == 'instagram' && (!item.story_config || !item.story_config.created)">
                                <Tooltip
                                  :text="$t('dash.bots.status_proxy')"
                                  position="top"
                                  class="reconnect-btn"
                                >
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="
                                      require('../../../assets/img/icon_wait_proxy.svg')
                                    "
                                    @click="reconnectePage(item.id)"
                                  />
                                  <a
                                    href="#"
                                    @click="reconnectePage(item.id)"
                                    v-html="$t('dash.pages.reconnectLabel')"
                                  ></a>
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template>
                              <template v-else-if="item.isGroup && item.network == 'instagram'">
                                <Tooltip
                                  :text="$t('dash.bots.conciergerie-ok')"
                                  position="top"
                                  class="full-conciergerie"
                                >
                                <span class="border"></span>
                                <vs-avatar
                                  color="transparent"
                                  size="18px"
                                  :src="
                                    require('../../../assets/img/icon_check_light.svg')
                                  "
                                />
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template>
                              <template v-if="!checkLock(item.network) || (!isUserPremiumActive && orderedPages.length && orderedPages[0].id != item.id && !isUserPartner)">
                                <Tooltip
                                  :text="getTooltipText(item)"
                                  position="top"
                                >
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="
                                      require('../../../assets/img/icon_check_light.svg')
                                    "
                                  />
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template> 
                              <template v-else-if="item.isGroup && item.network == 'instagram'">
                                <Tooltip :text="$t('dash.bots.conciergerie-ok-api-ko')" position="top">
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="require('../../../assets/img/icon-delete.svg')"
                                    @click="confirmRefresh(item)"
                                  />
                                  <!-- <a
                                    href="#"
                                    @click="confirmRefresh(item)"
                                    v-html="$t('dash.pages.refreshLabel')"
                                  ></a> -->
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template>
                              <template v-else-if="!!item.bot_status && item.bot_status == 1">
                                <!-- <Tooltip
                                  :text="$t('dash.pages.status_running') + (item.network == 'linkedin' ? ` - ${$t('dash.bots.next_refresh')} ${dateFromNow(item.expires_at)}` : '')"
                                  position="top"
                                > -->
                                <Tooltip
                                  :text="getTooltipText(item)"
                                  position="top"
                                >
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="
                                      require('../../../assets/img/icon_check_light.svg')
                                    "
                                    @click="confirmRefresh(item)"
                                  />
                                  <!-- <a
                                    href="#"
                                    @click="confirmRefresh(item)"
                                    v-html="$t('dash.pages.refreshLabel')"
                                  ></a> -->
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template>
                              <template v-else-if="!!item.bot_status && item.bot_status == 2">
                                <Tooltip :text="$t('dash.bots.status_near_expiration')+new Date(item.bot_error).toLocaleDateString()" position="top">
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="require('../../../assets/img/icon_warn.svg')"
                                    @click="confirmRefresh(item)"
                                  />
                                  <a
                                    href="#"
                                    @click="confirmRefresh(item)"
                                    v-html="$t('dash.pages.refreshLabel')"
                                  ></a>
                                </Tooltip>
                              </template>
                              <template v-else-if="item.bot_status == 0 && !checkLock('source_choice')">
                                <Tooltip :text="item.bot_error" position="top">
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="require('../../../assets/img/icon_stop.svg')"
                                    @click="['Admin', 'Editor'].includes(getUserRole) ? goToSettings() : null"
                                  />
                                  <a
                                    href="#"
                                    @click="confirmRefresh(item)"
                                    v-html="$t('dash.pages.refreshLabel')"
                                  ></a>
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template>
                              <template v-else-if="item.bot_status == 0 && item.network == 'linkedin'">
                                <Tooltip :text="$t('dash.bots.status_expired')" position="top">
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="require('../../../assets/img/icon_stop.svg')"
                                    @click="confirmRefresh(item)"
                                  />
                                  <a
                                    href="#"
                                    @click="confirmRefresh(item)"
                                    v-html="$t('dash.pages.refreshLabel')"
                                  ></a>
                                </Tooltip>
                              </template>
                              <template v-else-if="item.bot_status == 3">
                                <Tooltip :text="$t(item.bot_error)" position="top">
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="require('../../../assets/img/icon_stop.svg')"
                                    @click="['Admin', 'Editor'].includes(getUserRole) ? reactivateBot(item.id) : null"
                                  />
                                  <a
                                    href="#"
                                    @click="['Admin', 'Editor'].includes(getUserRole) ? reactivateBot(item.id) : null"
                                    v-html="$t('dash.sources.enable')"
                                  ></a>
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </template>
                              <template v-else-if="checkLock(item.network)">
                                <Tooltip :text="item.bot_error" position="top">
                                  <vs-avatar
                                    color="transparent"
                                    size="18px"
                                    :src="require('../../../assets/img/icon_stop.svg')"
                                    @click="confirmRefresh(item)"
                                  />
                                  <a
                                    href="#"
                                    @click="confirmRefresh(item)"
                                    v-html="$t('dash.pages.refreshLabel')"
                                  ></a>
                                </Tooltip>
                              </template>
                              <template v-else>
                                <vs-avatar
                                  color="transparent"
                                  size="18px"
                                  :src="require('../../../assets/img/icon_stop.svg')"
                                  style="cursor: default;"
                                  @click="confirmRefresh(item)"
                                />
                                <a
                                  href="#"
                                  @click="confirmRefresh(item)"
                                  v-html="$t('dash.pages.refreshLabel')"
                                ></a>
                              </template>
                            </div>
                          </vs-td>

                          <vs-td>
                            <div class="action-page">
                              <template v-if="['Admin', 'Editor'].includes(getUserRole)">
                                <vs-button 
                                  v-if="!checkLock(item.network) || (!isUserPremiumActive && index != 0 && !isUserPartner)"
                                  color="#6a1f4c"
                                  class="btn-large btn-img remove">
                                  <!-- <img src="../../../assets/img/icon-delete.svg" alt="remove"> -->
                                  <i class="material-icons">delete</i>
                                  <p>Supprimer</p>
                                </vs-button>
                                <vs-button 
                                  v-else
                                  @click="deleteLinked(item)"
                                  color="#6a1f4c"
                                  class="btn-large btn-img remove">
                                  <!-- <img src="../../../assets/img/icon-delete.svg" alt="remove"> -->
                                  <i class="material-icons">delete</i>
                                  <p>Supprimer</p>
                                </vs-button>
                                <!-- <vs-button @click="disconnectConciergerie(item.id)" v-if="item.story_config && (item.story_config.cookies || item.story_config.session_state)" color="#6a1f4c" class="btn-large btn-img remove disconnect-conciergerie">
                                    <p>{{$t("dash.pages.disconnect_conciergerie")}}</p>
                                </vs-button> -->
                              </template>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>

                <!--<div class="connected-pages">
                    <div class="linked-pages">
                        <div class="page" v-for="item in linked" :key="item.id">
                            <div
                              :class="{
                                'page-wrapper': true,
                                disabled: !checkLock(item.network)
                              }"
                            >
                                <button class="page-del" @click="deleteLinked(item)">x</button>
                                <button class="page-refresh" @click="confirmRefresh(item)">
                                    <img src="../../../assets/img/icon_connect_white.svg"
                                         alt="refresh">
                                </button>
                                <div class="page-content">
                                    <div class="vertical-align">
                                        <page-image-avatar :page="item"/>
                                        <p class="page-name">{{ item.name }}</p>
                                    </div>
                                </div>
                                <vs-button
                                  v-if="checkLock(item.network) && !['telegram', 'oneSignal', 'wonderpush', 'batch', 'google'].includes(item.network)"
                                  color="#303030"
                                  class="btn-img"
                                  size="small"
                                  @click="confirmRefresh(item)"
                                  vs-type="filled"
                                >
                                  <p>{{$t('dash.pages.refreshLabel')}}</p>
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>-->
            </vs-col>
        </vs-row>
        <!-- <vs-popup class="overlay posts-overlay-active-conciergerie" :title="$t(`dash.plan.active_conciergerie_now${activeConciergerie ? '_'+activeConciergerie.network : '' }`)" :active.sync="activeConciergerie"> -->
          <component-conciergerie-form 
            v-if="activeConciergerie"
            :page="activeConciergerie"
            :activeConciergerie="activeConciergerie"
            v-on:getPagesEvent="getPagesEvent"
            v-on:closeActiveConciergerie="closeActiveConciergerie"
          ></component-conciergerie-form>
        <!-- </vs-popup> -->
        <vs-popup class="overlay posts-overlay-change-plan-conciergerie" :title="$t('dash.plan.active_conciergerie_to_get_features_general')" :active.sync="changePlanConciergerie">
          <p>{{ $t('dash.plan.active_conciergerie_to_get_features_general.content') }}</p> 
          <br/>
          <vs-button
                  @click="goToSettings"
                  class="btn-large btn-img"
                  color="#303030"
                  vs-type="filled"
          >
              <p>{{$t('dash.button.changeplan')}}</p>
              <img src="../../../assets/img/icon_unlock.svg" alt="unlock">
          </vs-button>
        </vs-popup>
    </div>
</template>

<script>
  import componentPagesOverlay from './../overlay/Pages.vue'
  import componentGroups from '../overlay/Groups.vue'
  import Common from '../../mixins/Common'
  import Pages from '../../mixins/Pages'
  import Social from '../../mixins/Social'
  import Groups from '../../mixins/Groups'
  import Upgradable from '../../mixins/Upgradable'
  import Notif from '../../mixins/Notif'
  import User from '../../mixins/User'
  import PageImageAvatar from './../PageImageAvatar.vue'
  import componentLoader from './../overlay/Loader.vue'
  import componentConciergerie from './../overlay/Conciergerie.vue'
  import componentConciergerieForm from './../overlay/ConciergerieForm.vue'
  import Tooltip from './../tooltip/tooltipInit.vue'
  
  import moment from 'moment'

  export default {
    name: 'component-pages',

    components: {
      componentPagesOverlay,
      componentGroups,
      PageImageAvatar,
      componentLoader,
      componentConciergerie,
      componentConciergerieForm,
      Tooltip
    },

    mixins: [Common, Pages, Social, Upgradable, User, Groups, Notif],

    data() {
      return {
        dialog: {
          show: false,
          title: 'Pages',
          message: null
        },
        popup0: false,
        popup1: false,
        popup2: false,
        popupGroupsFB: false,
        popupTelegram: false,
        connected: {
          facebook: false,
          twitter: false,
          linkedin: false,
          instagram: false,
          tiktok: false,
          youtube: false,
          threads: false,
        },
        linked: [],
        unlinked: [],
        telegramChannelUrl: "",
        telegramChannelUrlIsCorrect: true,
        telegramBotName: '',
        noBotsAvailible: true,
        telegramInstructionGif: 1,
        telegramPopupHelp: false,
        groupsFBInstructionGif: 1,
        groupsFBPopupHelp: false,
        network: null,
        isGroup: false,
        popupPush : {
          active: false,
          isCorrect: true,
          network: null,
          name: null,
          network_id: null,
          token: null
        },
        pushNotifPopupHelp: false,

        selectedPage: null,
        popupGroup: false,
        group: {},
        groups: [],
        showLoader: false,
        pageFilter: '',
        activeConciergerie: false,
        changePlanConciergerie: false,
      }
    },

    computed: {
        getUserRole() {
        const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
        if(!user) return null
        if(user.admin)
          return 'Admin'
        else
          return user.role && user.role.length
                      ? user.role[0]
                      : 'Editor'
        
      },

      hideToFB() {
        const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
        if(!user) return null
        return user.email == 'fb.permission@mashup-web.com' || user.email == 'mwpermission@gmail.com'
      },

      activeLinkedinConciergerie() {
        const user = JSON.parse(localStorage.user)
        return this.checkLock('linkedin_credentials') //|| user.email.includes("@mashup-web.com")
      },

      activeInstagramConciergerie() {
        const user = JSON.parse(localStorage.user)
        return this.checkLock('instagram_credentials') //|| user.email.includes("@mashup-web.com")
      },
      
      activeNotificationsPush() {
        const user = JSON.parse(localStorage.user)
        return this.checkLock('push_notif_pub') || user.email.includes("@mashup-web.com")
      },

      getTypeNetwork() {
        if(this.network == 'facebook') 
          return this.isGroup ? '.facebook.groups' : '.facebook'
      
        return `.${this.network}`
      },

      listPages() {
        let pages = this.linked
        this.groups.forEach(group => {
          pages = pages.filter(l => !group.pages.includes(l.id))
        })
        let bots = localStorage.bots ? JSON.parse(localStorage.bots) : []
        //sort by bots active and pages name
        pages = pages.slice().sort((a,b) => {
          let aBots = bots.filter(bot => bot.page.id == a.id)
          let bBots = bots.filter(bot => bot.page.id == b.id)
          if((aBots.length == 0 && bBots.length == 0) || (aBots.length > 0 && bBots.length > 0))
            return (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0)
          else if(aBots.length > 0) return -1
          else if(bBots.length > 0) return 1
        })
        //sort pages by bots updated_at 
        pages = pages.slice().sort((a,b) => {
          let aBots = bots.filter(bot => bot.page.id == a.id)
          let bBots = bots.filter(bot => bot.page.id == b.id)
          if(aBots.length == 0 && bBots.length == 0) return 0 
          else if(aBots.length > 0 && bBots.length == 0) return -1
          else if(aBots.length == 0 && bBots.length > 0) return 1
          else if(aBots[0].updated_at < bBots[0].updated_at) return 1
          else if(aBots[0].updated_at > bBots[0].updated_at) return -1
          else return 0
        })
        return pages
      },

      orderedPages() {
        let pages = this.linked
        let bots = localStorage.bots ? JSON.parse(localStorage.bots) : []
        //sort by bots active and pages name
        pages = pages.slice().sort((a,b) => {
          let aBots = bots.filter(bot => bot.page.id == a.id)
          let bBots = bots.filter(bot => bot.page.id == b.id)
          if((aBots.length == 0 && bBots.length == 0) || (aBots.length > 0 && bBots.length > 0))
            return (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0)
          else if(aBots.length > 0) return -1
          else if(bBots.length > 0) return 1
        })
        //sort pages by bots updated_at 
        pages = pages.slice().sort((a,b) => {
          let aBots = bots.filter(bot => bot.page.id == a.id)
          let bBots = bots.filter(bot => bot.page.id == b.id)
          if(aBots.length == 0 && bBots.length == 0) return 0 
          else if(aBots.length > 0 && bBots.length == 0) return -1
          else if(aBots.length == 0 && bBots.length > 0) return 1
          else if(aBots[0].updated_at < bBots[0].updated_at) return 1
          else if(aBots[0].updated_at > bBots[0].updated_at) return -1
          else return 0
        })
        return pages
      }
    },

    beforeMount() {
      console.log('before mount')
      // Function definition
      // Be able to notify user a new page has been added
      const showSuccess = () => {
        //this.$vs.loading.close()
        this.showLoader = false
        /*
        this.$vs.dialog({
          color: 'primary',
          title: this.$t('dash.pages.refresh.title'),
          text: this.$t('dash.pages.refresh.success'),
          accept: () => {
            location.href = '/#/dash/pages'
          }
        })
        */
        // this.$vs.notify({
        this.notify({
          time: 10000,
          title: this.$t('dash.pages.refresh.title'),
          text: this.$t('dash.pages.refresh.success'),
          color:'success',
          id: 'norepeat'
        })
        //setTimeout(() => location.href = '/#/dash/pages', 2000);
      }

      const showFailed = (error) => {
        this.showLoader = false
        this.notify({
          time: 10000,
          title: this.$t('dash.pages.refresh.title'),
          text: this.$t(error),
          color:'success',
          id: 'norepeat'
        })
      }

      this.$ga.page(this.$router)

      localStorage.setItem('section', 'pages')

      const params = new URLSearchParams(location.search)

      const oauth_token = params.get('oauth_token')
      const oauth_verifier = params.get('oauth_verifier')
      const code = params.get('code')
      const state = params.get('state')
      console.log('code :', code)
      console.log('state :', state)
      console.log('oauth verifier:', oauth_verifier)
      console.log('oauth token :', oauth_token)

      if (oauth_token || oauth_verifier || code || state)
        localStorage.removeItem('redirect_params_url_action')

      // Twitter Login
      if (oauth_token && oauth_verifier) {
        this.network = 'twitter'
        this.isGroup = false
        //this.$vs.loading({ color: 'primary' })
        this.showLoader = true
        localStorage.removeItem('twitter_adding_page')
        let refresh_twitter_page = localStorage.refresh_twitter_page
        localStorage.removeItem('refresh_twitter_page')
        // this.newPage({
        this.addTwitterV1({
          network: 'twitter',
          oauth_token,
          oauth_verifier,
          refresh_page: refresh_twitter_page
        }).then((res) => {
          let messageLog = `${res.url} --- params: ${JSON.stringify({network:'twitter',oauth_token,oauth_verifier})} --- response: ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'add-page', messageLog)
          //showSuccess()
          history.replaceState({}, document.title, location.pathname)
        })
        // .then(() => {
        //   // launch api v2
        //   this.connectTwitter({ refresh: false, version: 2 })
        // }) 
        .then(this.getPages)
        .then(res => {
          const { pages } = res.body
          if (Array.isArray(pages) && pages.length > 0) {
            // If page(s) connected found
            localStorage.setItem('pages', JSON.stringify(pages))
            this.linked = pages
          }
          this.showLoader = false
        })
        .then(showSuccess)
        .catch(e => {
          console.log('err', e)
          if(e && e.body && e.body.error) showFailed(e.body.error)
        })     
      } 
      else if (code) {
        if(location.href.includes('youtube')){
          this.showLoader = true
          this.network = 'youtube'
          this.isGroup = false
          localStorage.removeItem('youtube_adding_page');
          this.postYoutubeVerify({ code }).then(result => {
            history.replaceState({}, document.title, location.pathname)
            console.log(result);
          }).then(this.getPages)
          .then(res => {
            const { pages } = res.body
            if (Array.isArray(pages) && pages.length > 0) {
              // If page(s) connected found
              localStorage.setItem('pages', JSON.stringify(pages))
              this.linked = pages          
            }
            this.showLoader = false
          }).then(showSuccess)
          .catch(e => {
            console.log('err', e)
            if(e && e.body && e.body.error) showFailed(e.body.error)
          })   
        }
        // if (state && state === localStorage.tiktok_adding_page) {
        else if (state && state == 'threads-connect') {
          this.showLoader = true
          this.network = 'threads'
          this.isGroup = false
          localStorage.removeItem('threads_adding_page');
          this.postThreadsVerify({ code }).then(result => {
            history.replaceState({}, document.title, location.pathname)
            console.log(result);
          }).then(this.getPages)
          .then(res => {
            const { pages } = res.body
            if (Array.isArray(pages) && pages.length > 0) {
              // If page(s) connected found
              localStorage.setItem('pages', JSON.stringify(pages))
              this.linked = pages
            }
            this.showLoader = false
          }).then(showSuccess)
          .catch(e => {
            console.log('err', e)
            if(e && e.body && e.body.error) showFailed(e.body.error)
          })   
        }
        else if (state && state != 'state') {
          this.showLoader = true
          this.network = 'tiktok'
          this.isGroup = false
          localStorage.removeItem('tiktok_adding_page');
          this.postTiktokVerify({ code }).then(result => {
            history.replaceState({}, document.title, location.pathname)
            console.log(result);
          }).then(this.getPages)
          .then(res => {
            const { pages } = res.body
            if (Array.isArray(pages) && pages.length > 0) {
              // If page(s) connected found
              localStorage.setItem('pages', JSON.stringify(pages))
              this.linked = pages
            }
            this.showLoader = false
          }).then(showSuccess)
          .catch(e => {
            console.log('err', e)
            if(e && e.body && e.body.error) showFailed(e.body.error)
          })   
        }
        else if(code.length == 211){
          this.showLoader = true
          this.network = 'linkedin'
          this.isGroup = false
          // Linkedin Login
          const isAddPage = localStorage.getItem('linkedin_adding_page')
          localStorage.removeItem('linkedin_adding_page')
          this.postLinkedinVerify({ code })
              .then(this.getLinkedInOrganizations)
              .then(({ body }) => {
                //Remove 'code' param in URL to prevent popup from coming back
                history.replaceState({}, document.title, location.pathname)

                const { elements = [] } = body
                this.pages.linkedin = elements.map(e => ({
                    name: e['organizationalTarget~'].localizedName,
                    network: 'linkedin',
                    network_id: e['organizationalTarget~'].id,
                    avatar: e['organizationalTarget~'].logoV2 ? e['organizationalTarget~'].logoV2['original~'].elements[1].identifiers[0].identifier : null
                }))
                localStorage.setItem(
                  'linkedinPages',
                  JSON.stringify(this.pages.linkedin)
                )
                this.setUnlinked()
              })
              .then(this.getPages)
              .then(res => {
                const { pages } = res.body
                if (Array.isArray(pages) && pages.length > 0) {
                  // If page(s) connected found
                  localStorage.setItem('pages', JSON.stringify(pages))
                  this.linked = pages
                  if(isAddPage){
                    this.setUnlinked()
                    this.popup1 = true
                  }
                }
                this.showLoader = false
              })
              .then(showSuccess)
              .catch(e => {
                console.log('err', e)
                if(e && e.body && e.body.error) showFailed(e.body.error)
              })   
        }
        else if(code.length == 40){
          this.showLoader = true
          console.log('network = pinterest')
          this.network = 'pinterest'
          this.isGroup = false
          // Linkedin Login
          this.postPinterestVerify({ code }).then( res => {
            console.log('restoken : ', res)
            
            //Remove 'code' param in URL to prevent popup from coming back
            history.replaceState({}, document.title, location.pathname)

            const oauth_token = res.body.token.access_token
            const name = res.body.user.username
            const expires_at = res.body.token.expires_in
            const network_id = res.body.user.username
            const avatar = res.body.user.profile_image || null
            var token = {}
            token.content = res.body.token.access_token
            token.network = 'pinterest'
            token.expires_at = res.body.token.expires_in
            token.network_id = res.body.user.username
            token.refresh_token = res.body.token.refresh_token
            token.refresh_token_expires_at = res.body.token.refresh_token_expires_in
            console.log('typeof content :', typeof token.content)
            console.log('name avatar token :', token)
            

            this.newPage({
              network: 'pinterest',
              token,
              name,
              avatar,
              network_id           
            }).then((res) => {
              let messageLog = `${res.url} --- params: ${JSON.stringify({network:'pinterest',token})} --- response: ${res.bodyText}`
              this.addLog(JSON.parse(localStorage.user), 'add-page', messageLog)
            })
          })
          .then(this.getPages)
          .then(res => {
            const { pages } = res.body
            if (Array.isArray(pages) && pages.length > 0) {
              // If page(s) connected found
              localStorage.setItem('pages', JSON.stringify(pages))
              this.linked = pages

            }
            this.showLoader = false
            //setTimeout( () => this.$router.push({ name: 'bots'}), 1500)
          })
          .then(showSuccess)
          .catch(e => {
            console.log('err', e)
            if(e && e.body && e.body.error) showFailed(e.body.error)
          })   
        
        }
        else if(state) {
          this.showLoader = true
          //twitter oauth2
          this.network = 'twitter'
          this.isGroup = false
          this.showLoader = true
          localStorage.removeItem('twitter_adding_page')        
          let refresh_twitter_page = localStorage.refresh_twitter_page
          // this.addTwitterV2({
          //   code
          this.newPage({
            network: 'twitter',
            code,
            refresh_page: refresh_twitter_page
          }).then((res) => {
            let messageLog = `${res.url} --- params: ${JSON.stringify({network:'twitter-v2',code})} --- response: ${res.bodyText}`
            this.addLog(JSON.parse(localStorage.user), 'add-page', messageLog)
            history.replaceState({}, document.title, location.pathname)
          })
          // .then(this.getPages)
          // .then(res => {
          //   const { pages } = res.body
          //   if (Array.isArray(pages) && pages.length > 0) {
          //     // If page(s) connected found
          //     localStorage.setItem('pages', JSON.stringify(pages))
          //     this.linked = pages
          //   }
          //   this.showLoader = false
          // })
          // .then(showSuccess)
          .then(() => {
            // launch api v1
            this.connectTwitter({ refresh: false, version: 1 })
          })
          .catch(e => {
            console.log('err', e)
            if(e && e.body && e.body.error) showFailed(e.body.error)
          })     
        }
      } else {
        this.showLoader = true
        this.getPages().then(res => {
          const { pages } = res.body
          if (pages && pages.length > 0) {
            // If page(s) connected found
            localStorage.setItem('pages', JSON.stringify(pages))
            this.linked = pages
            this.setUnlinked()
          } else {
            this.popup0 = true
          }
          this.showLoader = false
        })
      }

      setTimeout(this.fetchGroups(), 250)
    },


    methods: {

      getPagesEvent() {
        this.getPages().then(res => {
          const { pages } = res.body
          if (pages && pages.length > 0) {
            // If page(s) connected found
            localStorage.setItem('pages', JSON.stringify(pages))
            this.linked = pages
            this.setUnlinked()
          } else {
            this.popup0 = true
          }
        })
      },

      closeActiveConciergerie() {
        this.activeConciergerie = false
      },

      showConciergerieForm(pageId) {      
        this.activeConciergerie = this.findPage(pageId)
      },

      getPageFilter(){
        return this.listPages.filter(page => page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase()))
      },

      getGroupFilter(){
        return this.groups.filter(g => g.pages.some(p => this.checkPageFilter(this.findPage(p))))
      },

      checkPageFilter(page){
        if(!page) return false
        return page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase())
      },

      checkGroupFilter(group){
        if(!group) return false
        return group.pages.every(p => !this.checkPageFilter(this.findPage(p)))
      },

      async disconnectConciergerie(idPage) {
        console.log(idPage);
        await this.disconnectDirectApi(idPage);
        this.linked = this.linked.map(e => {
          if (e.id === idPage) {
            e.story_config = null;
          }
          return e;
        });
      },

      reconnectePage(id) {
        this.showConciergerieForm(id);
        // this.goToBot(id, 'connection')
      },

      reactivateBot(id) {
        this.goToBot(id, 'sources')
      },

      goToBot(id, scroll) {
        document.getElementsByClassName('vs-tooltip')[0].style.display = 'none';
        const bots = JSON.parse(localStorage.bots);
        //console.log(bots);
        let bot = bots.find(bot => bot.page.id === id);
        //console.log(bot);
        this.$router.push({ name: 'bots', params: { bot: bot.id, scroll } });
      },

      getTooltipText(page){
        if(page.network == 'linkedin') {
          if(!page.expires_at) return `${this.$t('dash.pages.status_running')} - ${this.$t('dash.bots.no_bot')}`
          else if(this.dateFromNow(page.expires_at))
            return `${this.$t('dash.pages.status_running')} - ${this.$t('dash.bots.next_refresh')} ${this.dateFromNow(page.expires_at)}`
          else
            return this.$t('dash.bots.status_expired')
        }
        else
          return this.$t('dash.pages.status_running')
      },

      dateFromNow(date){
        if(moment(date).isBefore(moment())) return false
        //let temps = moment(date).toNow(true)
        let temps = moment(date).toNow(true)
        temps = temps.replace('years', 'ans')
        temps = temps.replace('year', 'an')
        temps = temps.replace('months', 'mois')
        temps = temps.replace('month', 'mois')
        temps = temps.replace('hours', 'heures')
        temps = temps.replace('hour', 'heure')
        temps = temps.replace('days', 'jours')
        temps = temps.replace('day', 'jour')
        temps = temps.replace('un ', '1 ')
        temps = temps.replace('a ', '1 ')
        // temps = temps.replace(/\s/g, '')
        return temps
      },

      /*async fetchGroups(){
        let list = this.linked.map(l => l.id)
        await this.getGroups().then(res => {
          this.groups = res.filter(group => {
                            return group.pages.some(page => list.includes(page))
                          })
                          .map(group => {
                            return {...group, show: true}
                          })
          console.log('list', this.groups)
          
        })
      },*/
      fetchGroups(){
        let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
        this.getGroups().then(res => {
          this.groups = res.map(group => {
            // return {...group, show: true}
            return {...group, show: !hideGroups.find(g => g == group.id)}
          })
          
        })
      },
      
      addGroup(){
        this.group = {}
        this.popupGroup = true
      },

      findPage(pageId) {
        return this.linked.find(p => p.id == pageId)
      },

      checkPagesInGroup(group) {
        return group.pages.some(p => this.findPage(p))
      },

      editGroup(group){
        this.group = group
        this.popupGroup = true
      },

      toggleShowGroup(group) {
        let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
        if(group.show)
          hideGroups.push(group.id)
        else 
          hideGroups = hideGroups.filter(g => g != group.id)
        localStorage.setItem('hideGroups', JSON.stringify(hideGroups))
        
        let index = this.groups.findIndex(g => g.id == group.id)
        this.$set(this.groups[index], 'show', !group.show)
      },

      closeGroupOverlay(){
        this.group = {}
        this.popupGroup = false      
        this.fetchGroups()
      },

      activeFeature(feature){
        const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
        // const user = JSON.parse(localStorage.user)
        /*if(['google'].includes(feature)){                   // to remove ///////////////
          const accounts = [
            '35330abb-4b34-4228-bdfc-b5914645c02a', //so-imedia
          ]
          return accounts.includes(user.account) || user.email.includes("@mashup-web.com")                 // to remove ///////////////
        }
        else*/                                                            // to remove ///////////////
          return user && this.checkLock(feature) || user.email.includes("@mashup-web.com")
      },

      loginWithPinterest(){
        this.connectPinterest().then(res => {
          console.log('connect pinterest : ', res)
        })
      },

      loginWithYoutube() {
        this.connectYoutube().then(res => {
          console.log('connect youtube : ', res)
        })
      },

      loginWithThreads() {
        this.connectThreads().then(res => {
          console.log('connect threads : ', res)
        })
      },

      loginWithGoogle () {
        console.log('loginWithGoogle')
        //this.$vs.loading({ color: 'primary' })
        this.showLoader = true
        this.popup0 = false
        this.$gAuth.getAuthCode()
        .then(async authCode => {
          console.log('authCode', authCode)
          //let { pages } = this.getTokensGoogle(authCode)
          let res = await this.getTokensGoogle(authCode)
          if(res && res.body && !res.body.success)
            return console.log('error')
          console.log('pages', res.body.pages)
          this.pages.google = res.body.pages
        })
        .then(() => {
          this.network = 'google'
          console.log('setUnlinked Google')
          localStorage.setItem(
            'googlePages',
            JSON.stringify(this.pages.google)
          )
          this.setUnlinked()
          this.popup1 = true
          //this.$vs.loading.close()
          this.showLoader = false
        })
      },

      addPage() {
        //if plan 0 (free) and user not partner => limit to only one page
        if((!this.checkLock('bots_daily') && this.linked.length >= 1) && !this.checkLock('partner')){
          this.notifyNotPremium('dash.pages.cannot_add')
          return
        }

        this.popup0=true
      },

      /**
       * Facebook Logout
       */
      facebookLogout() {
        // eslint-disable-next-line
        FB.getLoginStatus(function (response) {
          if (response.status === 'connected') {
            // eslint-disable-next-line
            FB.logout(function (response) {
              //FB.Auth.setAuthResponse(null, 'unknown')
            })
          } else if (response.status === 'not_authorized') {
            // the user is logged in to Facebook,
            // but has not authenticated your app
          } else {
            // the user isn't logged in to Facebook.
            // eslint-disable-next-line
            console.log('response status not logged in')
          }
        })
      },

      /**
       * Facebook pages retrieve
       */
      connectFB() {
        this.network = 'facebook'
        this.isGroup = false
        this.$ga.event('pages', 'facebook-twitter')
        this.popup0 = false
        //this.$vs.loading({ color: 'primary' })
        this.showLoader = true
        // eslint-disable-next-line
        FB.login(
          response => {
            if (response.status === 'connected') {
              let uid =
                    (response.authResponse && response.authResponse.userID) || null
              let accessToken = response.authResponse.accessToken

              this.getUserInfoFb(accessToken).then(res => {
                let success = res.ok
                if (!success || success !== true) {
                  //this.$vs.loading.close()
                  this.showLoader = false
                  this.dialog.title = 'Error'
                  if (!res.body) {
                    this.dialog.message = 'Server not responding…'
                  } else {
                    this.dialog.message = res.statusText
                  }
                  this.dialog.show = true
                  return
                }

                this.getLongLiveToken(accessToken).then(res => {
                  let success = res.ok
                  if (!success || success !== true) {
                    //this.$vs.loading.close()
                    this.showLoader = false
                    this.dialog.title = 'Error'
                    if (!res.body) {
                      this.dialog.message = 'Server not responding…'
                    } else {
                      this.dialog.message = res.statusText
                    }
                    this.dialog.show = true
                    return
                  }
                  let body = {
                    id: uid,
                    token: res.body.access_token
                  }
                  localStorage.setItem('facebook', JSON.stringify(body))

                  const addPages = async (pages, initPages=false) => {
                    let success = pages.ok
                    if (!success || success !== true) {
                      this.showLoader = false
                      this.dialog.title = 'Error'
                      if (!pages.body) {
                        this.dialog.message = 'Server not responding…'
                      } else {
                        this.dialog.message = pages.statusText
                      }
                      this.dialog.show = true
                      localStorage.facebookPages = JSON.stringify([])
                      return
                    }

                    if(initPages) this.pages.facebook = []

                    for(let page of pages.body.data) {
                      console.log('Promise retrievePages FB next')
                      let newPage = {}
                      Object.keys(page).forEach(key => {
                        var value = page[key]
                        if (key === 'id') {
                          key = 'network_id'
                        } else if (key === 'picture') {
                          key = 'avatar'
                          value = value.data.url
                        }
                        newPage[key] = value
                      })
                      if(page.parent_page && page.parent_page.id && page.location && page.location.city)
                        newPage.name += ` (${page.location.city})`
                      this.pages.facebook.push(newPage)
                    }
                  }

                  this.retrievePages(body.token).then(res => {
                    //addPages(res, true)
                    let success = res.ok
                    if (!success || success !== true) {
                      //this.$vs.loading.close()
                      this.showLoader = false
                      this.dialog.title = 'Error'
                      if (!res.body) {
                        this.dialog.message = 'Server not responding…'
                      } else {
                        this.dialog.message = res.statusText
                      }
                      this.dialog.show = true
                      localStorage.facebookPages = JSON.stringify([])
                      return
                    }

                    this.pages.facebook = []

                    let nextPagesEndpoint = res.body.paging && res.body.paging.next ? res.body.paging.next : null

                    Promise.all(res.body.data.map(async page => {
                      console.log('Promise retrievePages FB')
                      //res.body.data.forEach(page => {
                        let newPage = {}
                        Object.keys(page).forEach(key => {
                          var value = page[key]
                          if (key === 'id') {
                            key = 'network_id'
                          } else if (key === 'picture') {
                            key = 'avatar'
                            value = value.data.url
                          }
                          newPage[key] = value
                        })
                        if(page.parent_page && page.parent_page.id && page.location && page.location.city)
                          newPage.name += ` (${page.location.city})`
                        this.pages.facebook.push(newPage)
                      //})
                    }))
                    .then(async () => {
                      while(nextPagesEndpoint){
                        await this.$http.get(nextPagesEndpoint)
                          .then(async nextPages => {
                            console.log('next', nextPages)
                            nextPagesEndpoint = nextPages.body.paging && nextPages.body.paging.next ? nextPages.body.paging.next : null
                            await addPages(nextPages)
                          })
                          .catch(e => {
                            console.log('err', e)
                            nextPagesEndpoint = null
                          })
                      }
                    })
                    
                    /*.then(() => {
                      this.retrieveGroups(uid, body.token).then(resGroups => {
                        let success = resGroups.ok
                        if (!success || success !== true) {
                        this.dialog.title = 'Error'
                        if (!resGroups.body) {
                          this.dialog.message = 'Server not responding…'
                        } else {
                          this.dialog.message = resGroups.statusText
                        }
                        this.dialog.show = true
                        localStorage.facebookPages = JSON.stringify([])
                        return
                        }

                        Promise.all(resGroups.body.data.map(async group => {
                          console.log('Promise retrieveGroups FB')
                          let newGroup = {}
                          Object.keys(group).forEach(key => {
                            var value = group[key]
                            if (key === 'id') {
                              key = 'network_id'
                            } else if (key === 'picture') {
                              key = 'avatar'
                              value = value.data.url
                            }
                            newGroup[key] = value
                          })
                          newGroup['access_token'] = body.token
                          this.pages.facebook.push(newGroup)
                        }))
                        .then(() => {
                          console.log('setUnlinked FB')
                          localStorage.setItem(
                            'facebookPages',
                            JSON.stringify(this.pages.facebook)
                          )
                          this.setUnlinked()
                          this.popup1 = true
                        })
                      })
                    })*/
                    .then(() => {
                      console.log('setUnlinked FB')
                      localStorage.setItem(
                        'facebookPages',
                        JSON.stringify(this.pages.facebook)
                      )
                      this.setUnlinked()
                      this.popup1 = true
                      //this.$vs.loading.close()
                      this.showLoader = false
                    })
                  })
                })
              })
            }
            else 
              this.showLoader = false
              //this.$vs.loading.close()
          },
          {
            scope:
              //'public_profile, pages_show_list, publish_pages, manage_pages, read_insights',
              'public_profile, pages_show_list, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content, pages_manage_metadata, pages_messaging, business_management, instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments, instagram_manage_messages',
              //'public_profile, pages_show_list, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content, pages_manage_metadata',
              //'public_profile, pages_show_list, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content, instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments, instagram_graph_user_profile, instagram_graph_user_media',
            return_scopes: true,
            auth_type: 'rerequest'
          }
        )
      },

      connectWhatsapp() {
        this.network = 'whatsapp'
        this.isGroup = false
        this.$ga.event('pages', 'whatsapp')
        this.popup0 = false
        this.showLoader = true
        // eslint-disable-next-line
        FB.login(
          response => {
            if (response.status === 'connected') {
              let uid =
                    (response.authResponse && response.authResponse.userID) || null
              let accessToken = response.authResponse.accessToken

              console.log('connected', uid, accessToken)

            }
            else 
              this.showLoader = false
              //this.$vs.loading.close()
          },
          {
            scope: 'whatsapp_business_management',
          // extras: {
          //   feature: 'whatsapp_embedded_signup',
          //   // setup: {
          //   //   ... // Prefilled data can go here
          //   // }
          // }
          }
        )
      },

      connectGroupsFB() {
        this.network = 'facebook'
        this.isGroup = true
        console.log('connectGroupsFB 3')
        this.$ga.event('pages', 'facebook-twitter')
        this.popup0 = false
        //this.$vs.loading({ color: 'primary' })
        this.showLoader = true
        this.popupGroupsFB = false
        // eslint-disable-next-line
        FB.login(
          response => {
            if (response.status === 'connected') {
              let uid =
                    (response.authResponse && response.authResponse.userID) || null
              let accessToken = response.authResponse.accessToken

              this.getUserInfoFb(accessToken).then(res => {
                let success = res.ok
                if (!success || success !== true) {
                  //this.$vs.loading.close()
                  this.showLoader = false
                  this.dialog.title = 'Error'
                  if (!res.body) {
                    this.dialog.message = 'Server not responding…'
                  } else {
                    this.dialog.message = res.statusText
                  }
                  this.dialog.show = true
                  return
                }

                this.getLongLiveToken(accessToken).then(res => {
                  let success = res.ok
                  if (!success || success !== true) {
                    //this.$vs.loading.close()
                    this.showLoader = false
                    this.dialog.title = 'Error'
                    if (!res.body) {
                      this.dialog.message = 'Server not responding…'
                    } else {
                      this.dialog.message = res.statusText
                    }
                    this.dialog.show = true
                    return
                  }
                  let body = {
                    id: uid,
                    token: res.body.access_token
                  }
                  localStorage.setItem('facebook', JSON.stringify(body))

                  const addPages = async (pages, initPages=false) => {
                    let success = pages.ok
                    if (!success || success !== true) {
                      this.showLoader = false
                      this.dialog.title = 'Error'
                      if (!pages.body) {
                        this.dialog.message = 'Server not responding…'
                      } else {
                        this.dialog.message = pages.statusText
                      }
                      this.dialog.show = true
                      localStorage.facebookPages = JSON.stringify([])
                      return
                    }

                    if(initPages) this.pages.facebook = []

                    for(let group of pages.body.data) {
                      console.log('Promise retrieveGroups FB')
                      let newGroup = {}
                      Object.keys(group).forEach(key => {
                        var value = group[key]
                        if (key === 'id') {
                          key = 'network_id'
                        } else if (key === 'picture') {
                          key = 'avatar'
                          value = value.data.url
                        }
                        newGroup[key] = value
                      })
                      newGroup['access_token'] = body.token
                      newGroup['isGroup'] = true
                      this.pages.facebook.push(newGroup)
                    }
                  }

                  this.retrievePages(body.token).then(res => {
                    let success = res.ok
                    if (!success || success !== true) {
                      //this.$vs.loading.close()
                      this.showLoader = false
                      this.dialog.title = 'Error'
                      if (!res.body) {
                        this.dialog.message = 'Server not responding…'
                      } else {
                        this.dialog.message = res.statusText
                      }
                      this.dialog.show = true
                      localStorage.facebookPages = JSON.stringify([])
                      return
                    }

                    this.pages.facebook = []

                    /*Promise.all(res.body.data.map(async page => {
                      console.log('Promise retrievePages FB')
                      //res.body.data.forEach(page => {
                        let newPage = {}
                        Object.keys(page).forEach(key => {
                          var value = page[key]
                          if (key === 'id') {
                            key = 'network_id'
                          } else if (key === 'picture') {
                            key = 'avatar'
                            value = value.data.url
                          }
                          newPage[key] = value
                        })
                        this.pages.facebook.push(newPage)
                      //})
                    }))
                    .then(() => { */
                      this.retrieveGroups(uid, body.token).then(resGroups => {
                        let success = resGroups.ok
                        if (!success || success !== true) {
                          //this.$vs.loading.close()
                          this.showLoader = false
                          this.dialog.title = 'Error'
                          if (!resGroups.body) {
                            this.dialog.message = 'Server not responding…'
                          } else {
                            this.dialog.message = resGroups.statusText
                          }
                          this.dialog.show = true
                          localStorage.facebookPages = JSON.stringify([])
                          return
                        }

                        let nextPagesEndpoint = resGroups.body.paging && resGroups.body.paging.next ? resGroups.body.paging.next : null

                       /* resGroups.body.data.forEach(page => {
                          let newPage = {}
                          Object.keys(page).forEach(key => {
                            var value = page[key]
                            if (key === 'id') {
                            key = 'network_id'
                            } else if (key === 'picture') {
                            key = 'avatar'
                            value = value.data.url
                            }
                            newPage[key] = value
                          })
                          this.pages.facebook.push(newPage)
                        })*/
                        Promise.all(resGroups.body.data.map(async group => {
                          console.log('Promise retrieveGroups FB')
                          let newGroup = {}
                          Object.keys(group).forEach(key => {
                            var value = group[key]
                            if (key === 'id') {
                              key = 'network_id'
                            } else if (key === 'picture') {
                              key = 'avatar'
                              value = value.data.url
                            }
                            newGroup[key] = value
                          })
                          newGroup['access_token'] = body.token
                          newGroup['isGroup'] = true
                          this.pages.facebook.push(newGroup)
                        }))
                        .then(async () => {
                          while(nextPagesEndpoint){
                            await this.$http.get(nextPagesEndpoint)
                              .then(async nextPages => {
                                console.log('next', nextPages)
                                nextPagesEndpoint = nextPages.body.paging && nextPages.body.paging.next ? nextPages.body.paging.next : null
                                await addPages(nextPages)
                              })
                              .catch(e => {
                                console.log('err', e)
                                nextPagesEndpoint = null
                              })
                          }
                        })
                        .then(() => {
                          console.log('setUnlinked FB')
                          localStorage.setItem(
                            'facebookPages',
                            JSON.stringify(this.pages.facebook)
                          )
                          this.setUnlinked()
                          this.popup1 = true
                          //this.$vs.loading.close()
                          this.showLoader = false
                        })
                      })
                    //})
                  })
                })
              })
            }
            else  
              this.showLoader = false
              //this.$vs.loading.close()
          },
          {
            scope: 'public_profile,pages_show_list,read_insights,pages_manage_posts,pages_manage_engagement,pages_read_user_content,publish_to_groups',
            return_scopes: true,
            auth_type: 'rerequest'
          }
        )
      },


      connectInstaDirect() {
        this.network = 'instagram';
        this.isGroup = false;
        this.popup0 = false;
        this.activeConciergerie = {
          network: 'instagram',
          id: 'createPage'
        }
      },

      /**
       * Instagram pages retrieve
       */
      connectInsta() {
        this.network = 'instagram'
        this.isGroup = false
        this.$ga.event('pages', 'facebook-twitter')
        this.popup0 = false
        //this.$vs.loading({ color: 'primary' })
        this.showLoader = true
        // eslint-disable-next-line
        FB.login(
          response => {
            if (response.status === 'connected') {
              let uid =
                    (response.authResponse && response.authResponse.userID) || null
              let accessToken = response.authResponse.accessToken

              this.getUserInfoFb(accessToken).then(res => {
                let success = res.ok
                if (!success || success !== true) {
                  //this.$vs.loading.close()
                  this.showLoader = false
                  this.dialog.title = 'Error'
                  if (!res.body) {
                    this.dialog.message = 'Server not responding…'
                  } else {
                    this.dialog.message = res.statusText
                  }
                  this.dialog.show = true
                  return
                }

                this.getLongLiveToken(accessToken).then(res => {
                  let success = res.ok
                  if (!success || success !== true) {
                    //this.$vs.loading.close()
                    this.showLoader = false
                    this.dialog.title = 'Error'
                    if (!res.body) {
                      this.dialog.message = 'Server not responding…'
                    } else {
                      this.dialog.message = res.statusText
                    }
                    this.dialog.show = true
                    return
                  }
                  let body = {
                    id: uid,
                    token: res.body.access_token
                  }
                  localStorage.setItem('facebook', JSON.stringify(body))

                  this.retrievePages(body.token).then(async res => {
                    let success = res.ok
                    if (!success || success !== true) {
                      //this.$vs.loading.close()
                      this.showLoader = false
                      this.dialog.title = 'Error'
                      if (!res.body) {
                        this.dialog.message = 'Server not responding…'
                      } else {
                        this.dialog.message = res.statusText
                      }
                      this.dialog.show = true
                      localStorage.instagramPages = JSON.stringify([])
                      return
                    }

                    let pagesFB = res.body.data
                    let nextPagesEndpoint = res.body.paging && res.body.paging.next ? res.body.paging.next : null
                    while(nextPagesEndpoint){
                      await this.$http.get(nextPagesEndpoint)
                        .then(async nextPages => {
                          console.log('next', nextPages)
                          nextPagesEndpoint = nextPages.body.paging && nextPages.body.paging.next ? nextPages.body.paging.next : null
                          pagesFB = pagesFB.concat(nextPages.body.data)
                        })
                        .catch(e => {
                          console.log('err', e)
                          nextPagesEndpoint = null
                        })
                    }
               
                    this.pages.instagram = []

                    // Promise.all(res.body.data.map(async page => {
                    Promise.all(pagesFB.map(async page => {
                      console.log('Promise retrievePages Insta')
                      await this.retrieveInstaPages(page.id, body.token).then(async resInstaPages => {
                        console.log('resInstaPages general', resInstaPages)
                        if(resInstaPages.body.instagram_business_account) {
                          console.log('resInstaPages', resInstaPages.body)
                          await this.getUserInfoInsta(resInstaPages.body.instagram_business_account.id, body.token).then(async resInfoInsta => {
                            console.log('resInfoInsta', resInfoInsta)

                            let newPage = {
                              network_id: resInfoInsta.body.id,
                              name: resInfoInsta.body.username,
                              network: 'instagram',
                              access_token: body.token,
                              avatar : resInfoInsta.body.profile_picture_url || null,
                              affected_to: page.id
                            }
                            this.pages.instagram.push(newPage)

                            console.log("retrieveInstaPages end")
                          
                           
                          })
                        }
                      })
                    }))
                    .then(() => {
                      console.log('setUnlinked Insta')
                      localStorage.setItem(
                        'instagramPages',
                        JSON.stringify(this.pages.instagram)
                      )
                      this.setUnlinked()
                      this.popup1 = true
                      //this.$vs.loading.close()
                      this.showLoader = false
                      console.log("open popup")
                    })

                    /*
                    res.body.data.forEach(async (page, key) => {
                      await this.retrieveInstaPages(page.id, body.token).then(resInstaPages => {
                        if(resInstaPages.body.instagram_business_account) {
                          console.log('resInstaPages', resInstaPages.body)
                          this.getUserInfoInsta(resInstaPages.body.instagram_business_account.id, body.token).then(resInfoInsta => {
                            console.log('resInfoInsta', resInfoInsta)
                           
                            let newPage = {
                              network_id: resInfoInsta.body.id,
                              name: resInfoInsta.body.username,
                              network: 'instagram',
                              access_token: body.token
                            }
                            this.pages.instagram.push(newPage)

                            console.log("retrieveInstaPages end", key)

                          })
                        }
                      })
                    })  

                    localStorage.setItem(
                      'instagramPages',
                      JSON.stringify(this.pages.instagram)
                    )
                    this.setUnlinked()
                    this.popup1 = true
                    
                    console.log("open popup")*/
                  })
                })
              })
            }
            else
              this.showLoader = false
              //this.$vs.loading.close()
          },
          {
            scope:
              // 'public_profile, pages_show_list, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content, instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments, instagram_manage_messages',
              'public_profile, pages_show_list, pages_read_engagement, pages_manage_metadata, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content, business_management, instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments, instagram_manage_messages',
            return_scopes: true,
            auth_type: 'rerequest'
          }
        )
      },

      /**
       * Update pages
       * @param {Object} linked - Linked pages object
       * @param {Object} unlinked - Unlinked pages object
       */
      validate(linked, unlinked) {
        this.linked = linked.slice(0)
        this.unlinked = unlinked.slice(0)

        localStorage.setItem('pages', JSON.stringify(linked))

        this.popup1 = false
        this.popup0 = false

        //localStorage.setItem('section', 'bots')
        //location.href = '/#/dash/bots'

        this.getPages().then(res => {
          const { pages } = res.body
          if (pages && pages.length > 0) {
            // If page(s) connected found
            localStorage.setItem('pages', JSON.stringify(pages))
            this.linked = pages
            this.setUnlinked()
          } else {
            this.popup0 = true
          }
        })
        .then(this.fetchGroups())
      },

      /**
       * Get pages
       */
      setUnlinked() {
        /*this.getAllPages().then(res => {
          const { pages } = res.body
          if (pages && pages.length > 0) {
            if (localStorage.facebookPages) {
              this.pages.facebook = JSON.parse(localStorage.facebookPages).filter(pFacebook => {
                let pageDefined = false
                pages.forEach(page => {
                  if(pFacebook.network_id == page.network_id)
                    pageDefined = true
                })
                return !pageDefined
              })
              this.unlinked = this.pages.facebook.filter(o1 => !this.linked.some(o2 => o1.network_id === o2.network_id))
            }
            if (localStorage.linkedinPages) {
              this.pages.linkedin = JSON.parse(localStorage.linkedinPages).filter(pLinkedin => {
                let pageDefined = false
                pages.forEach(page => {
                  if(pLinkedin.network_id == page.network_id)
                    pageDefined = true
                })
                return !pageDefined
              })
              let newUnlinked = this.pages.linkedin.filter(o1 =>
                !this.linked.some((o2) => o1.network_id.toString() === o2.network_id.toString())
              )
              if (this.pages.facebook)
                this.unlinked = this.unlinked.concat(newUnlinked)
              else
                this.unlinked = newUnlinked
            }
          }
        })*/

        if (localStorage.facebookPages) {
          this.pages.facebook = JSON.parse(localStorage.facebookPages)
          console.log('localStorage.facebookPages', JSON.parse(localStorage.facebookPages))
          this.unlinked = this.pages.facebook.filter(o1 =>
            !this.linked.some(o2 => o1.network_id.toString() === o2.network_id.toString())
          )
          /*this.linked = this.linked.concat(this.pages.facebook.filter(o1 =>
            !this.linked.some(o2 => o1.network_id === o2.network_id)
          ))*/
          localStorage.removeItem('facebookPages')
        }
        if(localStorage.instagramPages) {
          console.log('localStorage.instagramPages', JSON.parse(localStorage.instagramPages))
          this.pages.instagram = JSON.parse(localStorage.instagramPages)
          this.unlinked = this.pages.instagram.filter(o1 =>
            !this.linked.some(o2 => o1.network_id.toString() === o2.network_id.toString())
          )
          /*this.linked = this.linked.concat(this.pages.instagram.filter(o1 =>
            !this.linked.some(o2 => o1.network_id === o2.network_id)
          ))*/
          localStorage.removeItem('instagramPages')
        }
        if (localStorage.linkedinPages) {
          this.pages.linkedin = JSON.parse(localStorage.linkedinPages)
          let newUnlinked = this.pages.linkedin.filter(o1 =>
            !this.linked.some((o2) => o1.network_id.toString() === o2.network_id.toString())
          )
          if (localStorage.facebookPages)
            this.unlinked = this.unlinked.concat(newUnlinked)
          else
            this.unlinked = newUnlinked
          /*if (localStorage.facebookPages)
            this.linked = this.linked.concat(newUnlinked)
          else
            this.linked = newUnlinked*/
          localStorage.removeItem('linkedinPages')
        }
        if (localStorage.googlePages) {
          this.pages.google = JSON.parse(localStorage.googlePages)
          console.log('localStorage.googlePages', JSON.parse(localStorage.googlePages))
          this.unlinked = this.pages.google.filter(o1 =>
            !this.linked.some(o2 => o1.network_id.toString() === o2.network_id.toString())
          )
          localStorage.removeItem('googlePages')
        }
      },

      /**
       * Delete a page
       */
      deleteLinked(item) {
        this.$ga.event('pages', 'delete')
        this.$vs.dialog({
          type: 'confirm',
          color: '#501743',
          title: this.$t('dash.pages.delete.title'),
          text: this.$t('dash.pages.delete.description'),
          acceptText: "OK",
          accept: () => {
            this.deletePage(item.id).then((res) => {
              const { success, deleted } = res.body
              let messageLog = `${res.url} --- params: ${JSON.stringify(item)} --- response: ${deleted}`
              this.addLog(JSON.parse(localStorage.user), 'remove-page', messageLog)

              let index = this.linked.indexOf(item)
              if (index !== -1) {
                this.linked.splice(index, 1)
                localStorage.setItem('pages', JSON.stringify(this.linked))
                this.unlinked.push(item)
              }
              //location.reload()
              //location.href = '/#/dash/pages'
              this.getPages().then(res => {
                const { pages } = res.body
                if (pages && pages.length > 0) {
                  // If page(s) connected found
                  localStorage.setItem('pages', JSON.stringify(pages))
                  this.linked = pages
                  this.setUnlinked()
                } else {
                  this.popup0 = true
                }
              })
              .then(this.fetchGroups())
            })
          }
        })
      },

      /**
       * Delete a page from group
       */
       deleteLinkedFromGroup(item, group) {
        this.$ga.event('pages', 'delete')
        this.$vs.dialog({
          type: 'confirm',
          color: '#501743',
          title: this.$t('dash.pages.delete_group.title'),
          text: this.$t('dash.pages.delete_group.description'),
          acceptText: this.$t('dash.pages.delete_group.btn-remove-page'),
          accept: () => {
            this.deletePage(item.id).then((res) => {
              const { success, deleted } = res.body
              let messageLog = `${res.url} --- params: ${JSON.stringify(item)} --- response: ${deleted}`
              this.addLog(JSON.parse(localStorage.user), 'remove-page', messageLog)

              let index = this.linked.indexOf(item)
              if (index !== -1) {
                this.linked.splice(index, 1)
                localStorage.setItem('pages', JSON.stringify(this.linked))
                this.unlinked.push(item)
              }
              //location.reload()
              //location.href = '/#/dash/pages'
              this.getPages().then(res => {
                const { pages } = res.body
                if (pages && pages.length > 0) {
                  // If page(s) connected found
                  localStorage.setItem('pages', JSON.stringify(pages))
                  this.linked = pages
                  this.setUnlinked()
                } else {
                  this.popup0 = true
                }
              })
              .then(this.fetchGroups())
            })
          },
          cancelText: this.$t('dash.pages.delete_group.btn-remove-from-group'),
          cancel: () => {
            let body = {}
            if(group && group.id) 
              body = group
            body.pages = group.pages.filter(p => p != item.id)
            this.updateGroup(body)
            .then(this.fetchGroups())
          }
        })
      },

      openGroupsFBPopup: function() {
        this.popupGroupsFB = true;
        this.popup0 = false;
      },

      openPushPopup(type){
        console.log('openPushPopup',type)
        this.popup0 = false
        this.popupPush.active = true
        this.popupPush.isCorrect = true
        this.popupPush.network = type
        this.popupPush.name = null
        this.popupPush.network_id = null
        this.popupPush.token = null
      },

      validatePopupPush: function() {
        console.log('validatePopupPush', this.popupPush);

        if(!this.popupPush.name || this.popupPush.name == ""
          || !this.popupPush.network_id || this.popupPush.network_id == ""
          || !this.popupPush.token || this.popupPush.token == "") {
          this.popupPush.isCorrect = false;
          this.$vs.notify({
              time: 7000,
              color: 'warning',
              position: 'bottom-right',
              title: this.$t('dash.notifications.error_title'),
              text: this.$t('dash.pages.push.all_fields_required')
            });
            return
        }

        this.popupPush.active = false
          this.popupPush.isCorrect = true;

        let body = {
          'name': this.popupPush.name,
          'network': this.popupPush.network,
          'network_id': this.popupPush.network_id,
          'avatar': null,
          'token': this.popupPush.token
        }
        
        this.newPage(body).then(
          res => {
            const { success, page } = res.body

            let messageLog = `${res.url} --- params: ${JSON.stringify(body)} --- response: ${res.bodyText}`
            this.addLog(JSON.parse(localStorage.user), 'add-page', messageLog)

            if (!success || success !== true) {
              this.dialog.title = 'Error'
              if (!res.body) {
                this.dialog.message = 'Server not responding…'
              } else {
                this.dialog.message = res.body.statusText
              }
              this.dialog.show = true
              return
            }
          }
        )
      }, 

      openTelegramPopup: function() {
        this.$vs.loading({color: "#F8F8F8", container: this.$refs.loadingBotTarget.$el, scale: 0.7});
        this.getAvailibleTelegramBot().then(res => {
          this.$vs.loading.close(this.$refs.loadingBotTarget.$el);
          console.log(res);
          if (!res.body.bot) {
            this.popup0 = false;
            this.$vs.notify({
              time: 7000,
              color: 'warning',
              position: 'bottom-right',
              title: this.$t('dash.pages.telegram_no_availible_bot_title'),
              text: this.$t('dash.pages.telegram_no_availible_bot_text')
            });
            return;
          }
          this.telegramBotName = res.body.bot;
          this.popupTelegram = true;
          this.popup0 = false;
        });
      },

      validateTelegramChanel: function() {
        console.log(this.telegramChannelUrl);
        if (this.telegramChannelUrl.match(/https:\/\/t.me\/.*/)) {
          this.popupTelegram = false;
          this.connectTelegram({}, this.telegramChannelUrl, this.telegramBotName);
          this.telegramChannelUrlIsCorrect = true;
          this.telegramChannelUrl = '';

        } else {
          this.telegramChannelUrlIsCorrect = false;
        }
      }, 

      openTelegramHelpGif: function(instructionNumber) {
        this.telegramInstructionGif = instructionNumber;
        // this.popupTelegram = false;
        this.telegramPopupHelp = true;
      },

      openGroupsFBHelpGif: function(instructionNumber) {
        this.groupsFBInstructionGif = instructionNumber;
        this.groupsFBPopupHelp = true;
      },

      openPushNotifHelpGif(){
        this.pushNotifPopupHelp = true;
      },

    },

    created: function () {    
      localStorage.setItem('section', 'pages')
      if (localStorage.facebook) {
        this.connected.facebook = true
      }

      if (localStorage.twitter) {
        this.connected.twitter = true
      }

      if (localStorage.instagram) {
        this.connected.instagram = true
      }

      if (localStorage.tiktok) {
        this.connected.tiktok = true
      }

      if (localStorage.threads) {
        this.connected.threads = true
      }

      if (localStorage.youtube) {
        this.connected.youtube = true
      }
    },

    
  }
</script>
